import { C } from "./theme.js";

// Pantalla de espera de medio segundo mientras se comprueba si ya hay sesión
// compartida (cookie de *.dimoauto.com). Evita el parpadeo feo de ver el
// formulario de login y que desaparezca solo un instante después.
export default function Entrando({ texto = "Entrando…" }) {
  return (
    <div style={{
      minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
      background: C.bg, color: C.muted, fontSize: 13.5, fontWeight: 600, gap: 10,
    }}>
      <span className="fg-breath" style={{ width: 9, height: 9, borderRadius: "50%", background: C.brand }} />
      {texto}
    </div>
  );
}
